var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"home-page wrap"},[_c('transition',{attrs:{"name":"custom-classes-transition","enter-active-class":"animated fadeIn faster"}},[_c('router-view')],1),_c('PublicFooter')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }